import { render, staticRenderFns } from "./ChangePayPalAccountDialog.vue?vue&type=template&id=4f5dcf9f&scoped=true"
import script from "./ChangePayPalAccountDialog.vue?vue&type=script&lang=ts"
export * from "./ChangePayPalAccountDialog.vue?vue&type=script&lang=ts"
import style0 from "./ChangePayPalAccountDialog.vue?vue&type=style&index=0&id=4f5dcf9f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dcf9f",
  null
  
)

export default component.exports